export default __webpack_public_path__ + "static/media/EXTENROOF-BENGALURU.08684c91.jpg";